<template>
    <router-view ref="child" />
</template>
<script>
export default {
  name: "ParentView"
};
</script>
